import { HttpContext } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { NotesBaaSignRequestResolveDataService, NotesBaaSignRequestResolution } from '@ffd/api-client';
import { Observable, tap } from 'rxjs';
import { NOTES_BAA_SIGN_REQUEST_TOKEN } from './baa-sign-request.token';

@Injectable({ providedIn: 'root' })
export class BaaSignRequestResolveService {
  private readonly resolveDataService = inject(NotesBaaSignRequestResolveDataService);

  public readonly notesBaaSignRequestTokenSignal = signal<string | null>(null);
  public readonly resolutionSignal = signal<NotesBaaSignRequestResolution | null>(null);
  public readonly isSignRequestCompletedSignal = signal(false);

  public setToken(token: string): void {
    if (this.notesBaaSignRequestTokenSignal() !== token) {
      this.isSignRequestCompletedSignal.set(false);
    }
    this.notesBaaSignRequestTokenSignal.set(token);
  }

  public markSignRequestCompleted(): void {
    this.isSignRequestCompletedSignal.set(true);
  }

  public resolveToken$(): Observable<NotesBaaSignRequestResolution> {
    return this.resolveDataService
      .resolveNotesBaaSignRequest(undefined, undefined, {
        context: new HttpContext().set(NOTES_BAA_SIGN_REQUEST_TOKEN, this.notesBaaSignRequestTokenSignal()),
      })
      .pipe(tap((resolution) => this.resolutionSignal.set(resolution)));
  }
}
